/**
 * Purchase order line top statuses display names.
 */
export default {
  TOP_DAMAGED: 'Rejected',
  HAS_PHOTO: 'Approved',
  PHOTO_SHOOT_COMPLETE: 'Approved',
  RECEIVED_BY_SAMPLE_COORDINATOR: 'Approved',
  RECEIVED: 'Received',
  CANCELLED: 'Rejected',
  MOVED_TO_PHOTO_STUDIO: 'Approved',
  SAMPLE_READY_FROM_PHOTOSHOOT: 'Approved',
  PENDING_RECEIPT: 'Pending Receipt',
  REJECTED: 'Rejected',
  APPROVED: 'Approved',
  TOP_SAMPLE_READY_TO_PHOTO_STUDIO: 'Approved',
  TOP_SAMPLE_BACK_FROM_PHOTO_STUDIO: 'Approved',
  TOP_SAMPLE_IN_SAMPLE_COORDINATION_TEAM: 'Approved',
};
